import { render } from "./MentionsLegales.vue?vue&type=template&id=f766b258"
const script = {}

import "./MentionsLegales.vue?vue&type=style&index=0&id=f766b258&lang=css"

import exportComponent from "/Users/macbook13dbs1/Documents/Vue/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__